module.exports = __webpack_public_path__ + "img/release_202008_feedback-form.338da569.png";